import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomerOverViewService } from '../../customer-overview.service';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';
import { Customer, Reminder, SidebarOptions } from '~core/models';
import { CustomerService, NavigationService, ReminderService, ScreenSizeService } from '~core/services';
import { ReminderStatusTranslationsService } from '~shared/translations';
import { ButtonsTranslations } from '~shared/components/buttons/buttons-translations.service';
import { SidebarService } from '~core/components/sidebar/sidebar.service';
import { TooltipTranslationService } from '~shared/translations';

/**
 * This component is the page that views only the last contacts
 */
@UntilDestroy()
@Component({
  selector: 'app-reminder-page',
  templateUrl: './reminder-page.component.html',
  styleUrls: ['../../customer-overview.component.scss']
})
export class ReminderPageComponent implements OnInit, OnDestroy {
  public customer: Customer;

  public currentReminders: Array<Reminder>;
  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];

  public baseApi: string;
  public customQueries: Array<any> = [];

  constructor(
    public customerOverviewService: CustomerOverViewService,
    public customerService: CustomerService,
    public sidebarService: SidebarService,
    public reminderService: ReminderService,
    public navigationService: NavigationService,
    public buttonsTranslations: ButtonsTranslations,
    public reminderTranslations: ReminderStatusTranslationsService,
    public tooltipTranslations: TooltipTranslationService,
    public tablesTranslations: TablesTranslations,
    private screenSizeService: ScreenSizeService,

  ) {
    if (this.screenSizeService.screenSize === 'desktop') {
      this.sidebarService.setSidebar(new SidebarOptions(true, true));
    } else {
      this.sidebarService.setSidebar(new SidebarOptions(false, true));
    }
    this.navigationService.setCurrentPage('reminders');
    this.navigationService.setCurrentBreadcrumbs(['crm', 'customerProfile']);
    this.customerService.castSelectedCustomer.pipe(untilDestroyed(this))
      .subscribe(customer => this.customer = customer);

    this.reminderService.castReminderList.pipe(untilDestroyed(this))
      .subscribe(data => {
        if (data != null) {
          this.currentReminders = data;
        }
      });
    this.columns.push(this.tablesTranslations.i18nDeadline, this.tablesTranslations.i18nOwner,
      this.tablesTranslations.i18nComment, this.tablesTranslations.i18nStatus);
    this.keys.push(['deadline', 'owner.fullName', 'text', 'status']);
  }

  public ngOnInit(): void {
    this.getReminderEndpoint(this.customer.id);
  }

  public ngOnDestroy(): void {
    this.customerOverviewService.toggleAllModal(false);
  }

  /**
   * Open the edit reminder modal and pass the address data to it.
   */
  public editReminder(reminder: Reminder): any {
    this.customerOverviewService.toggleAllModal(false);
    this.customerOverviewService.toggleEditReminderModal(true);
    this.reminderService.announceCurrentReminder(reminder);
  }

  /**
   * Open the edit reminder modal and pass the address data to it.
   */
  public createReminder(): any {
    this.customerOverviewService.toggleAllModal(false);
    this.customerOverviewService.toggleCreateReminderModal(true);
  }

  public setNewReminderList(reminders: Array<any>): any {
    const data: Array<Reminder> = this.reminderService.createRemindersClass(reminders);
    this.reminderService.setReminderList(data);
  }

  /**
   * Get the tixx select submissions for the current customer.
   */
  public getReminderEndpoint(id: number): any {
    const endpoint = this.reminderService.getAllCustomerRemindersEndpoint(id);
    this.baseApi = endpoint[0];
    this.customQueries = endpoint[1];
  }
}
